import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { publicToolHead } from "@/lib/publicToolRoutes";

const Page = () => <Index toolKey="calculator" routeLang="es" />;

export const Route = createFileRoute("/herramientas/calculadora")({
  head: () => publicToolHead("calculator", "es"),
  component: Page,
  errorComponent: Page,
  notFoundComponent: Page,
});
